module.exports = __webpack_public_path__ + "static/media/Pattern1.9963bd2e.jpg";